/**
 * Used when Tilled may have accepted a payment confirmation but the client did not receive a
 * definitive result. A second intent must not be created until reconciliation resolves the first.
 */
export const paymentConfirmationOutcomeUnknownMessage =
  'Payment confirmation could not be verified. Do not retry while the payment is processing.'
